import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import { space3XL, spaceL, spaceM } from '@xing-com/tokens';

export const Container = styled.section`
  margin-top: ${space3XL};
`;

export const Header = styled.div`
  margin-bottom: ${spaceM};

  @media ${mediaConfined} {
    margin-bottom: ${spaceL};
  }
`;

export const Actions = styled.div`
  margin-top: ${spaceL};
  display: flex;
  justify-content: center;
`;
